import React from 'react';
import ReactDOM from 'react-dom/client';
import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import './index.css';
import App from './App';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next) 
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    supportedLngs: ['fr'], // add 'en' if you want to add 'english' language
    fallbackLng: "fr", // switch the 'fr' to 'en' to apply the multilanguage
    detection : {
      order: ['path','cookie', 'htmlTag', 'localStorage', 'sessionStorage',  'subdomain'],
      caches: ['cookie'],
    },
    backend : {
      loadPath: '/assets/locales/{{lng}}/translation.json', //languages file
    },
  });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

